'use strict'

import React from 'react';
import sendCommand from '../../app/utils/sendCommand.js';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);

class ActionItem extends React.Component {
  render() {
    let itemType=this.props.project.isProgramme===true ? "/programmes/" : "/projects/";
    return (
      <li>
        <a onClick={this.props.onClick} href={itemType+this.props.project.id+"/"+this.props.url+"/"+this.props.nextStage.id}>{this.props.label} {this.props.nextStage.name}</a>
      </li>

    );
  }
}

class ApproveAction extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    return (this.props.project.requestedStageTransition) ? (
      <ActionItem {...this.props} url="approve" label={labels.approve}/>
    ) : (
      null
    );
  }
}

class RetractAction extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    return (this.props.project.requestedStageTransition) ? (
      <ActionItem {...this.props} url="retract" label={labels.retractRequest}/>
    ) : (
      null
    );
  }
}

class RequestAction extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    return (!this.props.project.requestedStageTransition && !this.props.project.requestedStageException) ? (
      <ActionItem {...this.props} url="request" label={labels.request}/>
    ) : (
      null
    );
  }
}

class RecommendCloseAction extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    return (this.props.project.isClosing && this.props.project.recommendedProjectClosure===undefined) ? (
      <ActionItem {...this.props} url="recommend" label={labels.recommend}/>
    ) : null;
  }
}

class ApproveCloseAction extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    return (this.props.project.recommendedProjectClosure!==undefined && this.props.project.isClosing===true) ? (
      <ActionItem {...this.props} url="approve" label={labels.approve}/>
    ) : null;
  }
}

class RetractCloseAction extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    return (this.props.project.recommendedProjectClosure!==undefined && this.props.project.isClosing===true) ? (
      <ActionItem {...this.props} url="retract" label={labels.retract}/>
    ) : null;
  }
}

class PrepareProjectClosureAction extends React.Component {
  prepareClosure(event) {
    event.preventDefault();
    sendCommand({type:"prepareProjectClosure", project: {id: this.props.project.id}})
      .then(()=>window.location="/projects/"+this.props.project.id)
      .catch(error=>{
        console.log("[ERROR] not able to prepare closure, got ",error);
        alert("An error occured, please try again");
      });
  }

  render() {
    let labels=translations.getTranslation(this.props).menu;
    return (this.props.project.isClosing!==true && this.props.project.isCompleted!==true && this.props.project.isStarted===true) ? (
      <ActionItem {...this.props} onClick={this.prepareClosure.bind(this)} url="propose" label={labels.prepareProjectClosure} nextStage={{name: ""}}/>
    ) : null;
  }
}

class CloseActions extends React.Component {
  render() {
    var nextStage={id:"close",name:"project close"}
    return (
      <ul style={{marginBottom:0}}>
        <PrepareProjectClosureAction {...this.props} nextStage={nextStage}/>
        <RecommendCloseAction {...this.props} nextStage={nextStage}/>
        <RetractCloseAction {...this.props} nextStage={nextStage}/>
        <ApproveCloseAction {...this.props} nextStage={nextStage}/>
      </ul>
    );
  }
}

class StageActions extends React.Component {
  render() {
    return (
      <ul style={{marginTop:0}}>
        <RequestAction {...this.props}/>
        <RetractAction {...this.props}/>
        <ApproveAction {...this.props}/>
      </ul>
    );
  }
}

class Progress extends React.Component {
  findNextStage(project) {
    var nextStage=undefined;
    if (project.stages!==undefined && project.stages.length>0)  {
      var currentIndex=-1;
      if (project.currentStage!==undefined) {
        project.stages.forEach((stage,index) => {
          if (stage.id===project.currentStage.id) {
            currentIndex=index;
          }
        });
      }
      if (currentIndex+1<project.stages.length) {
        nextStage=project.stages[currentIndex+1];
      } else {
        var closeProject=true;
      }
    }
    return nextStage;
  }

  render() {
    let labels=translations.getTranslation(this.props).menu;
    var nextStage=this.findNextStage(this.props.project);
    return (
      <div>
        <b>{labels.progress}</b>
        <CloseActions {...this.props}/>
        {(this.props.project.state!=="completed" && nextStage!==undefined && !this.props.project.requestedStageException) ? (
          <StageActions {...this.props} nextStage={nextStage}/>
        ) :null }
      </div>
    );
  }
}

class StatusMenu extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    let itemType=this.props.project.isProgramme===true ? "/programmes/" : "/projects/";
    if (this.props.project.isRelease) {
      return (
        <div/>
      );
    }
    return this.props.project.state!=="completed" ? (
      <div>
        <b>{labels.status}</b>
        <ul>
          {this.props.user!==undefined && (this.props.project.isStopped || this.props.project.isPaused)? (
            <li>
              <a href={itemType+this.props.project.id+"/state/start"}>
                {this.props.project.isProgramme ? labels.startProgramme : labels.startProject}
              </a>
            </li>
          ) : (
            <li>
              {this.props.project.isProgramme ? labels.startProgramme : labels.startProject}
            </li>
          )}

          {this.props.user!==undefined && this.props.project.isStarted? (
            <li>
              <a href={itemType+this.props.project.id+"/state/pause"}>
                {this.props.project.isProgramme ? labels.pauseProgramme : labels.pauseProject}
              </a>
            </li>
          ) : (
            <li>
              {this.props.project.isProgramme ? labels.pauseProgramme : labels.pauseProject}
            </li>
          )}
          {this.props.user!==undefined && (this.props.project.isStarted || this.props.project.isPaused) ? (
            <li>
              <a href={itemType+this.props.project.id+"/state/stop"}>
                {this.props.project.isProgramme ? labels.stopProgramme : labels.stopProject}
              </a>
            </li>
          ) : (
            <li>
              {this.props.project.isProgramme ? labels.stopProgramme : labels.stopProject}
            </li>
          )}
        </ul>
      </div>
    ) : null;
  }
}

class PlanActions extends React.Component {
  render() {
    let currentStage=this.props.project!==undefined ? this.props.project.currentStage : undefined;
    return currentStage!==undefined && this.props.project.requestedStageException===undefined ? (
      <div>
        <b>Plan</b>
        <ul>
          <li><a href={"/projects/"+this.props.project.id+"/plan?exception=true"}>Request Exception Plan Approval</a></li>
        </ul>
      </div>
    ) : null;
  }
}

export default class ProjectMenu extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).menu;
    let project=this.props.project!==undefined
      ? this.props.project
      : this.props.programme!==undefined
        ? this.props.programme
        : this.props.product!==undefined
          ? this.props.product
          : this.props.release!==undefined
            ? this.props.release
            : undefined;
    let itemType=project===undefined
      ? "/projects/"
      : project.isProgramme===true
        ? "/programmes/"
        : project.isRelease
          ? "/releases/"
          : project.isProduct
            ? "/products/"
            : "/projects/";
    return this.props.showMenu===true ? (
      <div style={{position: "absolute", zIndex: 1, fontFamily:"Lato", backgroundColor:"white", color:"black", marginLeft: 150, marginTop: 2, padding:20,  width: 260, backgroundColor: "white", border:"1px solid #E5E5E5", boxShadow: "0px 8px 16px rgba(0,0,0,0.15)", borderRadius: 4}}>
        {project.isProduct!==true && project.isRelease!==true && project.isProgramme!==true? (
          <Progress {...this.props}/>
        ) : null }
        <PlanActions {...this.props}/>
        <div>
          {project.isProduct!==true ? (
            <StatusMenu {...this.props}/>
          ) : null}
          <b>{labels.actions}</b>
          <ul>
            {this.props.user!==undefined ? (
              <li>
                <a href={itemType+project.id+"/properties"}>{labels.editProperties}</a>
              </li>
            ) : (
              <li>{labels.editProperties}</li>
            )}
            {this.props.user!==undefined ? (
              <li>
                <a href={itemType+project.id+"/log"}>{labels.openLog}</a>
              </li>
            ) : (
              <li>{labels.openLog}</li>
            )}
            {project.isProgramme!==true
              && project.isRelease!==true
              && project.isProduct!==true ? (
              <li>
                <a href={itemType+project.id+"/settings"}>{labels.projectSettings}</a>
              </li>
            ) : null}
            {project.isProgramme!==true
              && project.isRelease!==true
              && project.isProduct!==true ? (
              <li>
                <a href={itemType+project.id+"/clone"}>{labels.cloneProject}</a>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./views/components/ProjectMenu.jsx